import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResolveAudienceResponse } from '../../models/campaign.model';

@Component({
  selector: 'app-audience-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './audience-dialog.component.html',
  styleUrls: ['./audience-dialog.component.css'],
})
export class AudienceDialogComponent {
  @Input() result: ResolveAudienceResponse | null = null;
  @Output() closed = new EventEmitter<void>();

  meta(p: { job_title?: string; department?: string; office_location?: string }): string {
    return [p.job_title, p.department, p.office_location].filter(Boolean).join(' · ');
  }

  close(): void {
    this.closed.emit();
  }
}
